import type { TFunction } from 'i18next';
import { object, string } from 'yup';

export const getValidationSchema = (t: TFunction) =>
  object().shape({
    name: string().required(t('Provider Name is required')),
  });
